import  { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AnimatedWrapper from '../components/AnimatedWrapper';
import { features } from '../config/data';
import amplitude from '../utils/amplitude';

export default function Page1() {
  const navigate = useNavigate();

  useEffect(() => {
    function setVh() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
    if(process.env.NODE_ENV === "production"){
      amplitude.track('Quiz Step Open', {
        step_number: 1,
      });
    }
    setVh();
    window.addEventListener('resize', setVh);
    return () => window.removeEventListener('resize', setVh);
  }, []);

  const handleNext = () => {
    if(process.env.NODE_ENV === "production"){
      amplitude.track('Quiz Step Complete', {
        step_number: 1,
      });

    }
    navigate('/quiz2');
  };

  return (
    <AnimatedWrapper>
      <div
        className="flex flex-col max-w-[400px] w-full mx-auto px-4"
        style={{ height: 'calc(var(--vh, 1vh) * 100)' }}
      >
        {/* Контентная часть со скроллом */}
        <div className="flex-1 overflow-y-auto py-6 scrollbar-hide">
          {/* Блок с изображениями */}
          <div className="relative w-full h-64 sm:h-72 mb-9">
            <img
              src="/img1.png"
              alt="Skincare"
              className="absolute top-[25px] left-[12%] h-[75%] w-auto"
            />
            <img
              src="/img2.png"
              alt="Skincare"
              className="absolute top-0 left-[40%] h-[75%] w-auto z-10"
            />
            <img
              src="/arrow.svg"
              alt="Arrow"
              className="absolute bottom-[10px] left-1/2 transform -translate-x-1/2 h-9 w-[160px] sm:w-[200px]"
            />
          </div>

          {/* Заголовки */}
          <h2 className="text-base sm:text-lg font-semibold text-center mb-2">
            Welcome to your program with face scan analysis
          </h2>
          <h3 className="text-base sm:text-lg font-semibold text-center mb-4">
            The program includes
          </h3>

          {/* Список преимуществ */}
          <ul className="text-sm sm:text-base w-full space-y-3">
            {features.map((feature, index) => (
              <li key={index} className="flex items-start gap-3">
                <img
                  src="/icon.svg"
                  alt="Check"
                  className="w-5 h-5 mt-1 flex-shrink-0"
                />
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Прикреплённая кнопка */}
        <div className="sticky bottom-2 bg-white z-10 pt-2 mb-2">
          <button
            onClick={handleNext}
            className="w-full bg-pinkCustom text-white py-3 sm:py-4 rounded-full font-semibold hover:bg-pinkCustom transition"
          >
            OK, I got it
          </button>
        </div>
      </div>
    </AnimatedWrapper>
  );
}
